import React from "react";

interface ErrorPageProps {
  statusCode: string;
  title: string;
  message: string;
  children?: React.ReactNode;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  statusCode,
  title,
  message,
  children,
}) => (
  <div className="flex h-screen items-start justify-center bg-white px-4 py-16 l:py-20 lg:py-24">
    <div className="w-full max-w-[512px] space-y-2 text-center text-gray-900">
      <div className="flex w-full flex-col items-center justify-start">
        <h1 className="text-main-600 text-5xl font-bold lg:text-6xl">{statusCode}</h1>
        <p className="text-lg font-semibold l:text-xl">{title}</p>
      </div>
      <p className="text-base font-normal">{message}</p>
      {children}
    </div>
  </div>
);

export default ErrorPage;
